<script>
import BlazeSlider from 'blaze-slider'
import 'blaze-slider/dist/blaze.css'
import { ArrowRightIcon, ArrowLeftIcon } from '@heroicons/vue/24/solid'
import youtubeHelpersMixin from '@/mixins/youtubeHelpersMixin.js'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import SlideShowSlide from '@/components/slide-show/public/slide-show-slide.vue'
import slideShowMixin from '@/mixins/slideShowMixin.js'

export default {
  name: 'FundraiserPageSlideShow',
  components: { SlideShowSlide, TwTransitionContainer, ArrowRightIcon, ArrowLeftIcon},
  mixins:[youtubeHelpersMixin, slideShowMixin],
  props: {
    fundraiserPage: {
      type: Object,
      required: true
    },
    showNavigation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      Slider: null,
      Slide: 1
    }
  },
  computed: {
    slideshow() {
      return this.fundraiserPage.slideshow
    },
    slides() {
      const slides = []
      if(this.fundraiserPage.fundraiser_layout_configuration.video_url) {
        slides.push({
          id: 0,
          type: 'youtube',
          thumbnail: `https://i.ytimg.com/vi/${this.getYoutubeIdFromUrl(this.fundraiserPage.fundraiser_layout_configuration.video_url)}/hqdefault.jpg`,
          url: this.fundraiserPage.fundraiser_layout_configuration.video_url
        })
      }
      if(this.fundraiserPage.slideshow) {
        this.fundraiserPage.slideshow.slides.forEach(slide => {
          if(slide.type === 'url') {
            console.log('processing slide type url:', slide.url)
            slides.push({
              ...slide,
              thumbnail: `https://i.ytimg.com/vi/${this.getYoutubeIdFromUrl(slide.url)}/hqdefault.jpg`,
              type: 'youtube'
            })
          }
          else {
            slides.push(slide)
          }
        })
      }
      if(this.fundraiserPage.fundraiser.slideshow && this.fundraiserPage.fundraiser.settings.enforce_slideshow) {
        this.fundraiserPage.fundraiser.slideshow.slides.forEach(slide => {
          slides.push(slide)
        })
      }
      return slides;
    }
  },
  mounted() {
    this.$nextTick( () => {
      if(this.slides.length === 0) return
      this.Slider = new BlazeSlider(document.querySelector('#slideshow-page-' + this.fundraiserPage.id), {
        all: {
          draggable: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          slidesGap: '1 rem',
        },
      })
      this.Slider.onSlide((pageIndex, firstSlideIndex, lastSlideIndex) => {
        this.Slide = pageIndex + 1
      })
    })
  }
}
</script>

<template>
  <tw-transition-container>
    <div v-if="slides && slides.length > 0" :id="'slideshow-page-' + fundraiserPage.id" class="blaze-slider">
      <div class="blaze-container mt-8">
        <div class="blaze-track-container">
          <div class="blaze-track h-20 sm:h-24 md:h-32">
            <slide-show-slide v-for="(slide, index) in slides" :key="'slideshow-slide-key-' + fundraiserPage.id + '-' + slide.id" readonly :slide="slide" class="flex justify-center h-full max-w-48" @clicked="slideShowItemClicked(index)" />
          </div>
        </div>
        <div v-if="showNavigation" class="flex justify-between mt-4">
          <button class="blaze-prev" aria-label="Go to previous slide">
            <ArrowLeftIcon class="size-5" />
          </button>
          <div class="pagination text-sm">
            {{ Slide }} / {{ slides.length }}
          </div>
          <button class="blaze-next" aria-label="Go to next slide">
            <ArrowRightIcon class="size-5" />
          </button>
        </div>
      </div>
    </div>
  </tw-transition-container>
</template>

<style scoped>

</style>
